import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initOneSignal } from "./push/onesignal";
import { supabase } from "./integrations/supabase/client";

initOneSignal();

// Intercept PASSWORD_RECOVERY event BEFORE any component mounts.
// This sets a sessionStorage flag that all shell auth guards check,
// preventing them from redirecting the user to their dashboard while
// they should be redirected to /reset-password instead.
supabase.auth.onAuthStateChange((event) => {
  if (event === "PASSWORD_RECOVERY") {
    sessionStorage.setItem("password_recovery_pending", "1");
  }
});

// MEDIUM FIX: Android hardware back button handling via Capacitor
// Prevents accidental app exit during live booking/payment flows.
const setupAndroidBackButton = async () => {
  try {
    const { App: CapacitorApp } = await import('@capacitor/app');
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      // Block back during sensitive booking flows
      const pathname = window.location.pathname;
      const protectedPaths = ['/booking-flow', '/hire-contract'];
      const isProtectedFlow = protectedPaths.some(p => pathname.startsWith(p));
      
      if (isProtectedFlow) {
        // Don't navigate back during active booking/payment
        console.log('[Capacitor] Back button blocked on protected flow:', pathname);
        return;
      }

      if (canGoBack) {
        window.history.back();
      } else {
        CapacitorApp.exitApp();
      }
    });
  } catch {
    // Not running in Capacitor — silently ignore
  }
};

setupAndroidBackButton();

createRoot(document.getElementById("root")!).render(
  React.createElement(App)
);